





















import Vue from 'vue';
import { HeroImage } from '@/components/ds';
import HeroArrow from '@/components/Hero/HeroArrow.vue';
import { getAssetPath } from '@/helpers/assets';

export default Vue.extend({
  components: {
    HeroImage,
    HeroArrow,
  },
  data() {
    return {
      icon: getAssetPath('img/letsgo.svg'),
      backgroundSrc: getAssetPath('img/BackgroundImage.svg'),
      maskUrl: getAssetPath('img/mask.svg'),
      imgSrc: getAssetPath('img/hero/intro.jpg'),
    };
  },
});
